import { Button, SxProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { fontFamilies } from '../../utils';
import { fFunction } from './types';

export type ButtonProps = {
    onClick?: fFunction;
    text?: string;
    disabled?: boolean;
    href?: string;
    target?: string;
    disableRipple?: boolean;
    sx?: SxProps;
    startIcon?: string | React.ReactElement;
    name?: string;
    content?: React.ReactNode | JSX.Element | string;
    endIcon?: string | React.ReactElement;
};

export const LinkButton = styled(Button)<ButtonProps>(({ theme }) => ({
    color: '#007BB8',
    fontFamily: fontFamilies.GraphikRegular,
    fontSize: `15px`,
    textTransform: 'none',
    padding: '0px',
    borderRadius: '0px',
    '&:hover': {
        backgroundColor: '#FFF',
    },
}));

export const LinkButtonV2 = styled(Button)<ButtonProps>(({ theme }) => ({
    color: 'black',
    fontFamily: fontFamilies.GraphikRegular,
    fontSize: `15px`,
    textDecoration: 'underline',
    lineHeight: '36px',
    letterSpacing: '0.75px',
    textTransform: 'none',
    padding: '0px',
    '&:hover': {
        color: '#3078B5',
        textDecoration: 'underline',
    },
}));

export function ETFLinkButton(props: ButtonProps) {
    const { onClick, disabled, text, name, content, ...rest } = props;
    return (
        <LinkButton size='small' disabled={disabled} onClick={onClick} name={name || text} {...rest}>
            {text || content}
        </LinkButton>
    );
}
